import { configService } from "@/settings/api-url";
const actions = {
  action_getUniversities({ commit }) {
    configService("public/universities").then((res) => {
      commit("UNIVERSITIES", res.data);
    });
  },
  async action_getBanners({ commit }) {
    try {
      const ads = await configService("normal_user/advertisements");
      const externalAds = await configService("normal_user/external_advertisements");
      const currentDate = new Date();
      const allAds: any = [...ads.data, ...externalAds.data]
        .filter((ad) => {
          if (
            ad.is_published &&
            currentDate >= new Date(ad.start_date) &&
            currentDate <= new Date(ad.end_date)
          ) {
            return ad;
          }
        })
        .map((ad) => {
          return {
            url: ad.banner_file.url,
            idCommerce: ad.city_id ? ad.city_id : null,
            external_url: ad.city_id ? null : ad.external_url,
          };
        });
      if (allAds.length === 0) {
        allAds.push({
          url: "/assets/images/todoscomemos/todoscomemos_banner.jpg",
          idCommerce: 0,
        });
      }
      commit("BANNERS", allAds);
    } catch (e) {}
  },
};

export default actions;
